/**
 * Kleiner roter Zähler an einem Navigations-Reiter (Ungelesen-Anzahl je Bereich). Bei 0 rendert nichts.
 * Bewusst rein visuell (aria-hidden am Punkt-Charakter) mit einem Screenreader-Text an der Zahl.
 */
export function NavBadge({ n }: { n: number }) {
  if (n <= 0) return null
  return (
    <span className="wf-navbadge" role="status" aria-label={`${n} ungelesen`}>
      {n > 99 ? '99+' : n}
    </span>
  )
}
